import { createPortal } from 'react-dom';

interface TooltipProps {
  children: JSX.Element | JSX.Element[];
  widthClass?: string;
  positionClasses: string;
}

/**
 * For a tooltip to be visible there must be a parent/ancestor element with the classes "relative" and "group"
 */
const TooltipLegacy = ({
  children,
  widthClass,
  positionClasses
}: TooltipProps) => {
  return (
    <div>
      <div
        className={`${
          widthClass ?? ''
        } ${positionClasses} absolute opacity-0 scale-0 bg-black text-white p-1 rounded transition-all z-30 group-hover:opacity-100 group-hover:scale-100`}
      >
        <div className="absolute left-1/2 -translate-x-1/2 -bottom-2 w-0 h-0 border-l-8 border-l-transparent border-r-8 border-r-transparent border-t-8 border-t-black"></div>
        <div className="relative">{children}</div>
      </div>
    </div>
  );
};

export default TooltipLegacy;
